export default {
  edit: { lazy: () => import('./GlobalOrgs'), component: 'GlobalOrgEdit' },
  list: { lazy: () => import('./GlobalOrgs'), component: 'GlobalOrgList' },
}
